import React, { useEffect, useState } from 'react'
import styles from './styles.module.css'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getGpgKey, addGpg } from '../../actions/encryptionKeys';
import { usePermission } from '../../hooks';
import Loader from "react-loader";
const Index = ({
    data,
    getGpgKey,
    addGpg,
    loading
}) => {
    
    const [file, setFile] = useState(null); // blob файла
    const { readRight, updateRight } = usePermission('Настройка', 'Ключи шифрования');
    
    useEffect(() => {
        getGpgKey();
    }, [])

    const selectFileHandler = e => {
        const file = e.target.files[0];
        setFile(prev => (file));
    }

    useEffect(() => {
        if (file !== null) {
            addGpg(file, data.result === 'ok' ? true : false);
            setFile(null);
        }
    }, [file])

    if (!readRight) {
        return (
            <div className={styles.wrapper}>
                <p className={styles.title}>Ключи шифрования</p>
                <p className={styles.error}>Не достаточно прав</p>
            </div>
        )
    }

  return (
    <div className={styles.wrapper}>
        <p className={styles.title}>Ключи шифрования</p>
        <div className={styles.import}>
            <label className={styles.button} htmlFor="fileInput">Импорт</label>
            {!loading && <input id="fileInput" hidden type="file" onChange={selectFileHandler}/>}
        </div>

        {!loading && data.result !== 'ok' && <p className={styles.key}>
            {data.result === 'error' ? data.error : data.result} <br/>
            {data.result === 'error' ? data.keyerror : data.result}
         </p>}
        
        {
            loading ? 
            <div className={styles.loader}><Loader color="#7b2b2a" loaded={false} /></div>
            :
            <>
            {data.result === 'ok' && 
            <div className={styles.key}>
                <div><span>Алгоритм: </span> {data.key.crypt}</div>
                <div><span>Дата выпуска: </span> {data.key.issued}</div>
                <div><span>Срок действия: </span> {data.key.expires}</div>
                <div><span>Идентификатор ключа: </span> {data.key.keyid}</div>
            </div>}
            </>
        }

    </div>
  )
}

const mapStateToProps = (state) => ({
    data: state.encryptionKeys.key,
    loading: state.encryptionKeys.loading
  });
    
export default withRouter(connect(mapStateToProps, { getGpgKey, addGpg })(Index));